module.exports = __webpack_public_path__ + "img/step6.b11d88f6.png";